import { getIn, setIn, hasIn } from "immutable";
import { NEW_CAMPAIGN_INITIAL_STATE, SHOP_DEFAULT_SETTINGS } from "lib/globals";

const useBindToContext = (
	BindToContext,
	value = null,
	onChange = null,
	specificValidation = null,
	getError = null,
	validation = true,
	debug = false
) => {
	if (debug) console.log("value changed", value);
	if (!BindToContext) return [value, onChange];
	const [{ state, setItem, validationErrors, validate }, path, inlineOnChange = null, type = "campaign"] =
		BindToContext;

	const hasError = !!(typeof getError === "boolean" ? getError : validationErrors[path]);

	//in case we add new settings we want out ui to work with old ones
	let returnValue = getIn(state, path.split("."));

	// const onRender = [];
	if ([null, undefined].includes(returnValue)) {
		returnValue =
			type === "campaign"
				? getIn(NEW_CAMPAIGN_INITIAL_STATE(), path.split("."))
				: getIn(SHOP_DEFAULT_SETTINGS("english"), path.replace("settings.", "").split("."));
		// onRender.push(() => setItem(path, returnValue));
	}

	return [
		returnValue,
		(value) => {
			setItem(path, value);
			if (inlineOnChange) {
				inlineOnChange(value, setItem)
			}
			if (validate && validation && hasError)
				validate(setIn(state, path.split("."), value), [specificValidation || path]);
		},
		hasError,
		// onRender
	]; //we're returning here [ value , onChange, hasError ]
};
export default useBindToContext;
